import React, { useEffect, useState } from 'react'
import { Dropdown, Nav, Tab } from 'react-bootstrap'
import DashboardFooter from '../../Common/DashboardFooter'
import CreateTaskStepModal from './CreatorTaskDetails/CreateTaskStepModal'
import AllTaskCreator from './CreatorTaskDetails/AllTaskCreator'


const NavCreatorTask = () => {

    const [show, setShow] = useState(false)
    const handleClose = () => setShow(false)
    const [active, setActive] = useState({
        first: true,
        second: false,
        third: false,
        fourth: false,
        six: false,
        fifth: false,
        seven: false,
        eigtht: false,
    })
    const handleActive = (type) => {
        let keyArr = Object.keys(active)
        let arr = { ...active }
        keyArr.forEach((curElem) => {
            if (curElem === type) {
                arr[curElem] = true

            } else {
                arr[curElem] = false
            }
        })
        setActive(arr)
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                            <Nav variant="pills" style={{ padding: "15px 28px 15px 28px" }} >
                                <Nav.Item onClick={() => handleActive("first")}>
                                    <Nav.Link className={active.first ? "active" : ""} >All Task</Nav.Link>
                                </Nav.Item>
                                <Nav.Item onClick={() => handleActive("second")}>
                                    <Nav.Link className={active.second ? "active" : ""}>Pending Tasks</Nav.Link>
                                </Nav.Item>
                                <Nav.Item onClick={() => handleActive("third")}>
                                    <Nav.Link className={active.third ? "active" : ""}>Approved Tasks</Nav.Link>
                                </Nav.Item>
                                <Nav.Item onClick={() => handleActive("fourth")}>
                                    <Nav.Link className={active.fourth ? "active" : ""}>Rejected Tasks</Nav.Link>
                                </Nav.Item>


                            </Nav>


                            <div className="add_new_task me-3" style={{ padding: "0px 28px 0 28px" }}>

                                <div className="theme-btn" onClick={() => setShow(true)}>Create Task</div>
                            </div>
                        </div>


                        <div className="setting_right_side_wrap creater-custom-footer">
                            <Tab.Content>
                                <Tab.Pane className={active.first ? "active show" : ""}>
                                    <AllTaskCreator first={active.first} url="fetch-task" type="all" />
                                </Tab.Pane>
                                <Tab.Pane className={active.second ? "active show" : ""}>

                                    <AllTaskCreator first={active.second} url="fetch-pending-task" type="pending" />
                                </Tab.Pane>
                                <Tab.Pane className={active.third ? "active show" : ""}>

                                    <AllTaskCreator first={active.third} url="fetch-approved-task" type="approved" />

                                </Tab.Pane>
                                <Tab.Pane className={active.fourth ? "active show" : ""}>

                                    <AllTaskCreator first={active.fourth} url="fetch-rejected-task" type="rejected" />
                                </Tab.Pane>

                            </Tab.Content>
                        </div>
                    </Tab.Container >
                    <DashboardFooter />
                    <CreateTaskStepModal show={show} handleClose={handleClose} />

                </div>
            </div>

        </>
    )
}

export default NavCreatorTask
